export const iomoDesignOptions = [
	{
		id: 'pole',
		model: 'Iomo',
		label: {
			de: 'Pole-mounted',
			en: 'Pole-mounted',
			fr: 'Pole-mounted',
		},
		description: {
			de: 'The floral shape of the Iomo provides space for more than just lighting. Sound, video and projections can be incorporated discreetly into individual luminaire configurations too. ',
			en: 'The floral shape of the Iomo provides space for more than just lighting. Sound, video and projections can be incorporated discreetly into individual luminaire configurations too.',
			fr: 'The floral shape of the Iomo provides space for more than just lighting. Sound, video and projections can be incorporated discreetly into individual luminaire configurations too. ',
		},
		pole: {
			de: 'Iomo Pole Description',
			en: 'Iomo Pole Description',
			fr: 'Iomo Pole Description',
		}
	},

	{
		id: 'ceiling',
		model: 'Iomo',
		label: {
			de: 'Ceiling-mounted',
			en: 'Ceiling-mounted',
			fr: 'Ceiling-mounted',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		pole: {
			de: '',
			en: '',
			fr: '',
		}
	},

	{
		id: 'wall',
		model: 'Iomo',
		label: {
			de: 'Wall-mounted',
			en: 'Wall-mounted',
			fr: 'Wall-mounted',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		pole: {
			de: '',
			en: '',
			fr: '',
		}
	},

	{
		id: 'floor',
		model: 'Iomo',
		label: {
			de: 'Floor-mounted',
			en: 'Floor-mounted',
			fr: 'Floor-mounted',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		pole: {
			de: '',
			en: '',
			fr: '',
		}
	},

];

export const iomoOpticalSystemOptions = [
	{
		id: 'Comfort',
		spc: {
			attributeID: 'root::LE_Version',
			valueId: 'Confort',
		},
		label: {
			de: 'Comfort',
			en: 'Comfort',
			fr: 'Comfort',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		code: '00'
	},

	{
		id: 'Performance',
		spc: {
			attributeID: 'root::LE_Version',
			valueId: 'Performance',
		},
		label: {
			de: 'Performance',
			en: 'Performance',
			fr: 'Performance',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		code: '01'
	},
];

export const iomoPoleHeightOptions = [4, 5, 6, 7, 8, 9, 10].map((num) =>
	({
		id: num + '',
		meter: num,
		label: {
			de: num + 'm',
			en: num + 'm',
			fr: num + 'm',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: ['POLE S 4', 'POLE S 5', 'POLE S 6', 'POLE S 7', 'POLE S 8', 'POLE S 9'][num - 4],
		price: [null, null, null, null, null, null, null, null][num - 4],
		// price: [null, 3380, 3584, 3789, 3994, 4199, null, null][num - 7],
		diameter: num <= 9 ?  89 : 109
	}));

export const iomoPoleDiameterOptions = [
	{
		id: '114',
		label: {
			de: '114,3 mm',
			en: '114,3 mm',
			fr: '114,3 mm',
		},
		description: {
			de: '',
			en: '',
			fr: ''
		},
		number: '114',
		diameter: 114.3,
		price: 123
	},
	{
		id: '140',
		label: {
			de: '139,7 mm',
			en: '139,7 mm',
			fr: '139,7 mm',
		},
		description: {
			de: '',
			en: '',
			fr: ''
		},
		number: '140',
		diameter: 139.7,
		price: 140
	},
	{
		id: '159',
		label: {
			de: '159 mm',
			en: '159 mm',
			fr: '159 mm',
		},
		description: {
			de: '',
			en: '',
			fr: ''
		},
		number: '159',
		diameter: 159.0,
		price: 159
	},
	{
		id: '76',
		label: {
			de: 'Zopfmaß 76 mm',
			en: 'Top diameter 76 mm',
			fr: 'Top diameter 76 mm',
		},
		description: {
			de: '',
			en: '',
			fr: ''
		},
		number: '76',
		diameter: 76,
		price: 159
	},
	{
		id: '89',
		label: {
			de: 'Zopfmaß 89 mm',
			en: 'Top diameter 89 mm',
			fr: 'Top diameter 89 mm',
		},
		description: {
			de: '',
			en: '',
			fr: ''
		},
		number: '89',
		diameter: 89,
		price: 159
	},
];


export const iomoPoleShapeOptions = [
	{
		id: 'cylindrical',
		label: {
			de: 'zylindrisch',
			en: 'cylindrical',
			fr: 'cylindrical',
		},
		description: {
			de: '',
			en: '',
			fr: ''
		},
		number: '1'
	},
	{
		id: 'conical',
		label: {
			de: 'konisch',
			en: 'conical',
			fr: 'conical',
		},
		description: {
			de: '',
			en: '',
			fr: ''
		},
		number: '2',
	}
];

export const iomoNumberOfHeadsOptions = [1, 2, 3, 4, 5, 6, 7, 8].map((num) =>
	({
		id: num + '',
		number: num,
		label: {
			de: num + '',
			en: num + '',
			fr: num + '',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	}));

export const iomoBracketOptions = [
	{
		id: '250',
		label: {
			de: '250mm',
			en: '250mm',
			fr: '250mm',
		},
		description: {
			de: 'Iomo 250 mm Ausleger 1 ...',
			en: 'Iomo 250 mm Bracket 1 ...',
			fr: 'Iomo 250 mm Bracket 1 ...'
		},
		number: 'SX 97-514-9',
		price: 337
	},
	{
		id: '195',
		label: {
			de: '195 mm',
			en: '195 mm',
			fr: '195 mm',
		},
		description: {
			de: 'Iomo 195 mm Ausleger 1 ...',
			en: 'Iomo 195 mm Bracket 1 ...',
			fr: 'Iomo 195 mm Bracket 1 ...'
		},
		number: 'SX 97-515-9',
		price: 312
	},
	{
		id: '160',
		label: {
			de: '160mm',
			en: '160mm',
			fr: '160mm',
		},
		description: {
			de: 'Iomo 160 mm Ausleger 1 ...',
			en: 'Iomo 160 mm Bracket 1 ...',
			fr: 'Iomo 160 mm Bracket 1 ...'
		},
		number: 'SX 97-552-9',
		price: 150
	},
];

export const iomoHousingSizeOptions = [
	{
		id: '160',
		label: {
			de: '160mm',
			en: '160mm',
			fr: '160mm',
		},
		description: {
			de: 'Allows max. 1000 lm per head ...',
			en: 'Allows max. 1000 lm per head ...',
			fr: 'Allows max. 1000 lm per head ...',
		},
		code: '2'
	},
	{
		id: '195',
		label: {
			de: '195mm',
			en: '195mm',
			fr: '195mm',
		},
		description: {
			de: 'Allows max. 2000 lm per head ...',
			en: 'Allows max. 2000 lm per head ...',
			fr: 'Allows max. 2000 lm per head ...',
		},
		code: '3'
	},
	{
		id: '250',
		label: {
			de: '250mm',
			en: '250mm',
			fr: '250mm',
		},
		description: {
			de: 'Allows max. 3000 lm per head ...',
			en: 'Allows max. 3000 lm per head ...',
			fr: 'Allows max. 3000 lm per head ...',
		},
		code: '4'
	},
];

export const iomoColourTemperatureOptions = [
	{
		id: '2200K',
		label: {
			de: '2200 K',
			en: '2200 K',
			fr: '2200 K',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		code: '11'
	},
	{
		id: '2700K',
		label: {
			de: '2700 K',
			en: '2700 K',
			fr: '2700 K',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		code: '22'
	},
	{
		id: '3000K',
		label: {
			de: '3000 K',
			en: '3000 K',
			fr: '3000 K',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		code: '33'
	},
	{
		id: '4000K',
		label: {
			de: '4000 K',
			en: '4000 K',
			fr: '4000 K',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		code: '44'
	}
];

export const iomoReflectorColourOptions = [
	{
		id: 'gold',
		label: {
			de: 'Gold',
			en: 'Gold',
			fr: 'Gold',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'silver',
		label: {
			de: 'Silber',
			en: 'Silver',
			fr: 'Silver',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		code: '22'
	}
];

export const iomoLightDistributionOptions = [
	{
		id: '4',
		label: {
			de: '4°',
			en: '4°',
			fr: '4°',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		angle: 4,
		intensity: 100,
		code: '01'
	},
	{
		id: '9',
		label: {
			de: '9°',
			en: '9°',
			fr: '9°',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		angle: 9,
		intensity: 70,
		code: '02'
	},
	{
		id: '15',
		label: {
			de: '15°',
			en: '15°',
			fr: '15°',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		angle: 15,
		intensity: 50,
		code: '03'
	},
	{
		id: '30',
		label: {
			de: '30°',
			en: '30°',
			fr: '30°',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		angle: 30,
		intensity: 25,
		code: '04'
	},
	{
		id: '45',
		label: {
			de: '45°',
			en: '45°',
			fr: '45°',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		angle: 45,
		intensity: 18,
		code: '05'
	},
	{
		id: '60',
		label: {
			de: '60°',
			en: '60°',
			fr: '60°',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		angle: 60,
		intensity: 14,
		code: '06'
	},
	{
		id: '5x40',
		label: {
			de: '5° x 40°',
			en: '5° x 40°',
			fr: '5° x 40°',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		angle: 40,
		intensity: 20,
		code: '11'
	},
	{
		id: '25x70',
		label: {
			de: '25° x 70°',
			en: '25° x 70°',
			fr: '25° x 70°',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		angle: 70,
		intensity: 10,
		code: '12'
	},
	{
		id: 'pathway',
		label: {
			de: 'Gehweg',
			en: 'Pathway',
			fr: 'Pathway',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		angle: 45,
		intensity: 20,
		code: '21'
	},
];

export const iomoCapOptions = [
	{
		id: 'short',
		label: {
			de: 'kurz (Standard)',
			en: 'short',
			fr: 'short',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'long',
		label: {
			de: 'lang',
			en: 'long',
			fr: 'long',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'asymmetric',
		label: {
			de: 'asymmetrisch',
			en: 'asymmetric',
			fr: 'asymmetric',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	}
];
export const iomoModifierOptions = [
	{
		id: 'none',
		label: {
			de: 'keine',
			en: 'none',
			fr: 'none',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'honeycomb',
		label: {
			de: 'Wabenraster',
			en: 'Honeycomb Grid',
			fr: 'Honeycomb Grid',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	}
];

export const iomoHeadTypeOptions = [
	{
		id: 'luminaire',
		label: {
			de: 'Luminaire',
			en: 'luminaire',
			fr: 'luminaire',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
];

export const iomoBaseOptions = [
	{
		id: 'buriedbase',
		label: {
			de: 'durchgehendes Erdstück',
			en: 'Buried base',
			fr: 'enfouissement',
		},
		description: {
			de: 'durchgehendes Erdstück',
			en: 'Buried base',
			fr: 'enfouissement',
		},
		number: '',
	},
	{
		id: 'FlangePlateDE',
		label: {
			de: 'Flanschplatte 240 (Typ DE)',
			en: 'Flange Plate 240 (Type DE)',
			fr: 'semelle 240x240 mm',
		},
		description: {
			de: 'Flanschplatte 240 (Typ DE)',
			en: 'Flange Plate 240 (Type DE)',
			fr: 'semelle 240x240 mm',
		},
		number: '',
	},
	{
		id: 'FlangePlateFRsmall',
		label: {
			de: 'Flanschplatte 200 (Typ FR)',
			en: 'Flange Plate 200 (Type FR)',
			fr: 'semelle entraxe 200x200 mm',
		},
		description: {
			de: 'Flanschplatte 200 (Typ FR)',
			en: 'Flange Plate 200 (Type FR)',
			fr: 'semelle entraxe 200x200 mm',
		},
		number: '',

	},
	{
		id: 'FlangePlateFR',
		label: {
			de: 'Flanschplatte 300 (Typ FR)',
			en: 'Flange Plate 300 (Type FR)',
			fr: 'semelle entraxe 300x300 mm',
		},
		description: {
			de: 'Flanschplatte 300 (Typ FR)',
			en: 'Flange Plate 300 (Type FR)',
			fr: 'semelle entraxe 300x300 mm',
		},
		number: '',
	},
];

export const iomoSeparateBuriedBaseOptions = [
	{
		id: 'none',
		label: {
			de: 'nein',
			en: 'none',
			fr: 'aucun'
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: '',
	},
	{
		id: 'separateBuriedBase',
		label: {
			de: 'separates Erdstück',
			en: 'separate base',
			fr: 'pièce de terre séparée',
		},
		description: {
			de: 'separates Erdstück',
			en: 'separate base',
			fr: 'pièce de terre séparée',
		},
		poleHeights: {
			4: {
				height: 1600,
				number: 'SX 97-051-0',
				price: 883
			},
			5: {
				height: 1600,
				number: 'SX 97-051-0',
				price: 883
			},
			6: {
				height: 1600,
				number: 'SX 97-051-0',
				price: 883
			},
			7: {
				height: 1600,
				number: 'SX 97-051-0',
				price: 883
			},
			8: {
				height: 1600,
				number: 'SX 97-051-0',
				price: 883
			},
			9: {
				height: 1800,
				number: 'SX 97-055-0',
				price: 1267
			},
			10: {
				height: 1800,
				number: 'SX 97-055-0',
				price: 1267
			}
		},
	}
];
export const iomoSecondDoorOptions = [
	{
		id: 'none',
		label: {
			de: '1 Masttür',
			en: '1 Pole Door',
			fr: '1 porte de mât',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		designs: {
			pole: {
				de: 'Höhe der Unterkante: 600mm; Größe 500mm x 85mm',
				en: 'Height of lower edge : 600mm; Size 500mm x 85mm',
				fr: 'Höhe Unterkante: 600mm; Taille 500mm x 85mm'
			},
		}
	},
	{
		id: 'secondDoor',
		label: {
			de: '2 Masttüren',
			en: '2 Pole Doors',
			fr: '2 porte de mât',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		designs: {
			pole: {
				de: 'Höhe der Unterkante Tür 1: 600 mm, Tür 2: 1200mm; Größe 500 mm x 85 mm',
				en: 'Height of lower edge of door 1: 600 mm, Door 2: 1200mm; Size 500 mm x 85 mm',
				fr: 'Hauteur du bord inférieur de la porte 1: 600 mm, porte 2: 1200 mm; Taille 500 mm x 85 mm'
			},
		}
	}
];
export const iomoFuseBoxOptions = [
	{
		id: 'none',
		label: {
			de: 'nein',
			en: 'none',
			fr: 'aucun'
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		number: '',
	},
	{
		id: 'fusebox',
		label: {
			de: 'Kabelsicherungskasten',
			en: 'fuse box',
			fr: 'boitier fusible',
		},
		description: {
			de: 'Kabelsicherungskasten IP55 zur bauseitigen Montage, 2x5x6mm² für Durchgangsverdrahtung, Schutzklasse II',
			en: 'IP55 fuse box for site mounting, 2x5x6mm² for through-wiring, Protection Class II',
			fr: 'boitier fusible IP55 pour montage sur site, pour passage en coupure 2x5x6mm², classe électrique 2',
		},
		number: 'SX 97-030-0',
		price: 115
	}
];
export const iomoBuriedBaseSizeOptions = [800, 1000, 1200, 1500, 2000].map((num) =>
	({
		id: num + '',
		size: num,
		label: {
			de: num + 'mm',
			en: num + 'mm',
			fr: num + 'mm',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	}));


export const environmentOptions = [
	{
		id: 'day',
		label: {
			de: 'Tag',
			en: 'Day',
			fr: 'Day',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		texture: 'brown_photostudio_02_1k.exr',
		background: '#fff',
		intensity: 1
	},
	{
		id: 'night',
		label: {
			de: 'Nacht',
			en: 'Night',
			fr: 'Night',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		},
		texture: 'ferndale_studio_03_1k.exr',
		background: '#000',
		intensity: 0.6
	}
];
